import { render, staticRenderFns } from "./ChipsRate.vue?vue&type=template&id=857600fe"
import script from "./ChipsRate.vue?vue&type=script&lang=ts"
export * from "./ChipsRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports